const today = new Date();
const day = 24 * 60 * 60 * 1000;

export const DATA_SOURCE = {
  DUMMY: "dummy",
  LIVE: "live",
};

export const getDataSource = () =>
  process.env.REACT_APP_DATA_SOURCE === DATA_SOURCE.DUMMY
    ? DATA_SOURCE.DUMMY
    : DATA_SOURCE.LIVE;

export const isDummyDataEnabled = () =>
  process.env.NODE_ENV === "test" && getDataSource() === DATA_SOURCE.DUMMY;

export const cloneDummy = (value) => JSON.parse(JSON.stringify(value));

export const dummyUsers = [
  {
    _id: "demo-ramya",
    userId: "QM6569",
    name: "RAMYA",
    username: "RAMYA",
    activeUser: true,
    isLive: true,
    balance: 485000,
    baseQuantity: 130,
    sbaseQuantity: 170,
    targetPoints: 70,
    slPoints: 32,
    stockMaxPoints: 42,
    stockMaxLossPoints: 18,
    total: 9503.5,
    high: 9633.5,
    low: -1810,
    maxProfit: 9633.5,
    maxLoss: -1810,
    sensexPl: 1229,
    livePnl: [
      {
        _id: "demo-nfo-pos-1",
        tradingsymbol: "NIFTY26MAY23900PE",
        product: "MIS",
        quantity: 65,
        average_price: 94.2,
        ltp: 113.1,
        actual: 1228.5,
        change: 0,
        exchange: "NFO",
        tag: "NIFTY",
      },
      {
        _id: "demo-bfo-pos-1",
        tradingsymbol: "SENSEX26MAY76400CE",
        product: "MIS",
        quantity: 20,
        average_price: 324.5,
        ltp: 343.85,
        actual: 387,
        change: 0,
        exchange: "BFO",
        tag: "SENSEX",
      },
    ],
  },
  {
    _id: "demo-kavya",
    userId: "VSR557",
    name: "KAVYA",
    username: "KAVYA",
    activeUser: true,
    isLive: true,
    balance: 325000,
    baseQuantity: 65,
    sbaseQuantity: 0,
    targetPoints: 55,
    slPoints: 25,
    stockMaxPoints: 35,
    stockMaxLossPoints: 15,
    total: 4049,
    high: 4088,
    low: -765,
    maxProfit: 4088,
    maxLoss: -765,
    sensexPl: 0,
    livePnl: [
      {
        _id: "demo-kavya-nfo-pos-1",
        tradingsymbol: "BANKNIFTY26MAY55200PE",
        product: "MIS",
        quantity: 30,
        average_price: 152.4,
        ltp: 139.2,
        actual: -396,
        change: 0,
        exchange: "NFO",
        tag: "BANKNIFTY",
      },
    ],
  },
  {
    _id: "demo-chethan",
    userId: "ED5355",
    name: "CHETHAN",
    username: "CHETHAN",
    activeUser: true,
    isLive: true,
    balance: 250000,
    baseQuantity: 65,
    sbaseQuantity: 0,
    targetPoints: 60,
    slPoints: 30,
    stockMaxPoints: 30,
    stockMaxLossPoints: 14,
    total: 0,
    high: 0,
    low: 0,
    maxProfit: 0,
    maxLoss: 0,
    sensexPl: 0,
    livePnl: [],
  },
  {
    _id: "demo-tejas",
    userId: "TBR866",
    name: "TEJAS",
    username: "TEJAS",
    activeUser: true,
    isLive: false,
    balance: 410000,
    baseQuantity: 65,
    sbaseQuantity: 80,
    targetPoints: 50,
    slPoints: 22,
    stockMaxPoints: 28,
    stockMaxLossPoints: 12,
    total: 2017,
    high: 2091,
    low: -381,
    maxProfit: 2091,
    maxLoss: -381,
    sensexPl: 0,
    livePnl: [
      {
        _id: "demo-tejas-nfo-pos-1",
        tradingsymbol: "NIFTY26MAY24000CE",
        product: "MIS",
        quantity: -65,
        average_price: 105.6,
        ltp: 98.4,
        actual: 468,
        change: 0,
        exchange: "NFO",
        tag: "NIFTY",
      },
    ],
  },
];

export const dummyStocks = [
  {
    _id: "stock-heromotoco",
    tradingsymbol: "HEROMOTOCO",
    instrument_token: 345089,
    stockBuffer: 18,
    targetPoints: 42,
  },
  {
    _id: "stock-reliance",
    tradingsymbol: "RELIANCE",
    instrument_token: 738561,
    stockBuffer: 12,
    targetPoints: 35,
  },
  {
    _id: "stock-hdfcbank",
    tradingsymbol: "HDFCBANK",
    instrument_token: 341249,
    stockBuffer: 10,
    targetPoints: 28,
  },
];

export const dummyStockPl = [
  {
    _id: "demo-ramya",
    userId: "QM6569",
    username: "RAMYA",
    isLive: true,
    total: 4532,
    high: 7082,
    low: -3033,
    livePnl: [
      {
        _id: "demo-nse-pos-1",
        tradingsymbol: "HEROMOTOCO",
        product: "MIS",
        quantity: 170,
        average_price: 4972.14,
        ltp: 5017,
        actual: 4532,
        change: 0,
        exchange: "NSE",
        tag: "EQ",
      },
    ],
  },
  {
    _id: "demo-kavya",
    userId: "VSR557",
    username: "KAVYA",
    isLive: true,
    total: 0,
    high: 0,
    low: 0,
    livePnl: [
      {
        _id: "demo-kavya-nse-pos-1",
        tradingsymbol: "HDFCBANK",
        product: "MIS",
        quantity: 100,
        average_price: 1468.5,
        ltp: 1476.4,
        actual: 790,
        change: 0,
        exchange: "NSE",
        tag: "EQ",
      },
    ],
  },
  {
    _id: "demo-tejas",
    userId: "TBR866",
    username: "TEJAS",
    isLive: false,
    total: -840,
    high: 1140,
    low: -1290,
    livePnl: [
      {
        _id: "demo-tejas-nse-pos-1",
        tradingsymbol: "RELIANCE",
        product: "MIS",
        quantity: 80,
        average_price: 1367.5,
        ltp: 1357,
        actual: -840,
        change: 0,
        exchange: "NSE",
        tag: "EQ",
      },
    ],
  },
];

const optionSymbols = [
  ["NIFTY26MAY24000CE", 0.55, 105.6, 0.05, -33.54, 28363205, 95.5],
  ["NIFTY26MAY24000PE", 84.75, 125.7, 15.15, 42.87, 646100, 95.5],
  ["NIFTY26MAY23950CE", 0.1, 183, 0.05, -23.38, 29356795, 92.6],
  ["NIFTY26MAY23950PE", 35.25, 76.9, 7.7, 7.22, 1126125, 92.6],
  ["NIFTY26MAY23900CE", 14.75, 192.9, 4.6, -20.27, 2641275, -85.4],
  ["NIFTY26MAY23900PE", 0.05, 32.95, 0.05, -11.34, 33773740, -85.4],
];

export const dummyTickData = [
  {
    symbol: "NIFTY 50",
    ltp: 23976.75,
    change: -0.23,
    initialPrice: 23984.05,
    niftyOrderCount: 2,
    bankNiftyInitialPrice: 55232.3,
    bankNiftyOrderCount: 1,
    sensexInitialPrice: 76328.55,
    sensexOrderCount: 1,
  },
  ...optionSymbols.map(([symbol, ltp, high, low, diff, sellQuantity, net]) => ({
    _id: `tick-${symbol}`,
    symbol,
    ltp,
    diff,
    sellQuantity,
    net,
    data: { ohlc: { high, low } },
  })),
];

export const dummyStocksTickData = [
  {
    _id: "stocktick-heromotoco",
    symbol: "HEROMOTOCO",
    ltp: 5015,
    change: 0.72,
    open: 4979,
    high: 5029,
    low: 4953,
    initial: 4963,
    caputredPoints: 27.66,
    ordersCount: 2,
  },
  {
    _id: "stocktick-reliance",
    symbol: "RELIANCE",
    ltp: 1357,
    change: -0.73,
    open: 1371,
    high: 1388,
    low: 1348,
    initial: 1364,
    caputredPoints: -9.8,
    ordersCount: 1,
  },
];

export const dummyMarket = {
  bankNifty: { last_price: 55035.55, change: -0.47 },
  sensex: { last_price: 75944.78, change: -0.71 },
  indiaVix: { last_price: 16.22, change: 2.1 },
  buffer: {
    sellBuffer: 20,
    buyBuffer: 20,
    totalNet: 24.66,
    ceBuffer: -60,
    peBuffer: 60,
    niftyFixedPrice: 23900,
    currentSignal: "HOLD",
    ordersCount: 2,
  },
};

export const dummyOrders = [
  {
    _id: "demo-order-1",
    order: "SELL",
    symbol: "NIFTY",
    tradingsymbol: "NIFTY26MAY23900CE",
    expiry: "26MAY",
    type: "CE",
    quantity: 130,
    variance: 42,
    marginQunatity: 130,
    marginVariance: 20,
    isVerified: true,
    isLiveToTrade: true,
    status: "WAITING",
  },
  {
    _id: "demo-order-2",
    order: "SELL",
    symbol: "SENSEX",
    tradingsymbol: "SENSEX26MAY76400PE",
    expiry: "26MAY",
    type: "PE",
    quantity: 65,
    variance: 68,
    marginQunatity: 65,
    marginVariance: 26,
    isVerified: false,
    isLiveToTrade: false,
    status: "PAUSED",
  },
];

export const dummyOpenOrders = {
  charges: 1542.5,
  data: [
    {
      order_id: "open-1",
      order_timestamp: today.toISOString(),
      tradingsymbol: "HEROMOTOCO",
      transaction_type: "BUY",
      quantity: 170,
      average_price: 4972.14,
      last_price: 5017,
      pnl: 4617,
      change: 0.9,
      status: "OPEN",
      product: "MIS",
      exchange: "NSE",
      tag: "EQ",
    },
    {
      order_id: "open-2",
      order_timestamp: new Date(today.getTime() - 15 * 60 * 1000).toISOString(),
      tradingsymbol: "SENSEX26MAY76400CE",
      transaction_type: "SELL",
      quantity: 65,
      average_price: 324.5,
      last_price: 343.85,
      pnl: 1229,
      change: 0,
      status: "TRIGGER PENDING",
      product: "MIS",
      exchange: "BFO",
      tag: "SENSEX",
    },
    {
      order_id: "done-1",
      order_timestamp: new Date(today.getTime() - 45 * 60 * 1000).toISOString(),
      tradingsymbol: "NIFTY26MAY23900PE",
      transaction_type: "BUY",
      quantity: 65,
      average_price: 94.2,
      status: "COMPLETE",
      product: "MIS",
      exchange: "NFO",
    },
  ],
};

export const dummyConsole = Array.from({ length: 12 }, (_, index) => {
  const date = new Date(today.getTime() - (11 - index) * day);
  const profit = index % 4 === 0 ? -1850 - index * 80 : 2400 + index * 360;
  const charges = 210 + index * 12;
  return {
    _id: `console-${index}`,
    date: date.toISOString(),
    capital: 300000 + index * 2500,
    buyQunatity: 130,
    high: profit + 920,
    low: profit < 0 ? profit - 540 : -820,
    charges,
    profit,
    totalProfit: profit - charges,
    captured: Number(((profit - charges) / 130).toFixed(2)),
    profitPercentage: Number(((profit - charges) / 300000 * 100).toFixed(2)),
    misOrders: dummyOpenOrders.data,
  };
});

export const dummyProfits = [
  {
    realized: 42850,
    charges: 3920,
  },
];

export const dummyBalance = {
  equity: {
    available: {
      opening_balance: 485000,
      live_balance: 493240,
      cash: 238600,
    },
  },
};

export const dummyHeatMap = {
  data: [
    ["ADANIENT", 4.33, 2973, 489950],
    ["TMPV", 3.31, 385.6, 21346],
    ["TECHM", 1.71, 1460, 1725],
    ["ETERNAL", 1.34, 251, 24447],
    ["ONGC", 0.84, 287.35, 10629],
    ["MARUTI", 0.52, 13238, 256],
    ["SBIN", 0.02, 969.8, 16269],
    ["RELIANCE", -0.73, 1357, 13769],
    ["HDFCBANK", -0.84, 780.25, 31528],
    ["POWERGRID", -0.86, 292.8, 5625],
    ["INFY", -0.21, 1166, 8005],
    ["COALINDIA", -0.46, 455.9, 17073],
  ].map(([symbol, pchange, lastPrice, tradedVolume]) => ({
    symbol,
    pchange,
    lastPrice,
    tradedVolume,
  })),
};

export const dummyInitialGraphData = {
  data: Array.from({ length: 28 }, (_, index) => {
    const label = today.getTime() - (27 - index) * 60 * 1000;
    const value = index % 2 === 0 ? 20 + index * 2 : -(12 + index);
    return {
      label,
      NIFTY: {
        NIFTY: { value, nsignal: value > 0 ? "BUY" : "SELL" },
        BANKNIFTY: { value: value * 1.6, nsignal: value > 0 ? "BUY" : "SELL" },
        SENSEX: { value: value * 2.2, nsignal: value > 0 ? "BUY" : "SELL" },
      },
    };
  }),
};
